exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clinic-log-entry{border-bottom:1px solid #e0e0e0;border-top:1px solid #e0e0e0;padding:5px 0;font-size:14px}.clinic-log-entry:nth-child(2n){background-color:#e0e0e0}.clinic-log-entry__code code{font-size:.75rem;cursor:pointer;color:var(--theme-text)}.clinic-log-entry__code code:hover{color:var(--theme-color)}", ""]);

// exports
